module.exports = "<a (click)=\"goBack()\" class=\"btn btn-outline-secondary\">\r\n    <i class=\"fa fa-reply\"></i>{{ 'Retour' | translate }}\r\n</a>\r\n"